'use client';
import { arrayOf } from '@s7/utils';
import { atomicTask } from '../utils/atomicTask/atomicTask.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const atomicFetch = (hash, client, query)=>{
    return atomicTask(hash, /*#__PURE__*/ _async_to_generator(function*() {
        const [input, options] = arrayOf(query);
        return client(input, options);
    }));
};

export { atomicFetch };
//# sourceMappingURL=atomicFetch.js.map
